<div class="main-page1">
  <nav class="navbar navbar-expand-lg navbar-light bg-light header">
    <!-- <a class="navbar-brand" (click)="redirectTo()"> <span class="nav-divnk time"><i class="fa fa-long-arrow-left"
          style="font-size:48px;color:#fff;margin-top:-16px;"></i></span></a> -->
    <!-- <div class="form-inline my-2 my-lg-0">
      <span class="nav-divnk">{{title}}</span>
    </div> -->
    <div class="logo"><a (click)="redirect()"><img src="assets/logo-4.png"></a></div>
  </nav>
  <div class="container">
    <div class="add-buy-main">
      <div class="add-buy-inner">
        <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
        <form [formGroup]="form" (ngSubmit)="save(form.value)">
          <div class="card" formArrayName="actions" *ngFor="let b of form.get('actions')['controls']; let i = index">
            <div class="absolute" *ngIf="i > '0'" (click)="removeCategory(i)"><i style="padding: 8px;
          border-radius: 55%;color: white;" class="fa fa-times" aria-hidden="true"></i>
            </div>
            <div [formGroupName]="i">
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4 ">
                    <label for="staticEmail" class="col-form-label">Offer/Action</label>
                  </div>
                  <div class="col-sm-8">
                    <select formControlName="offer" id="action" class="form-control">
                      <option value="Buy">Buy</option>
                      <option value="Get">Get</option>
                      <option value="Spend">Spend</option>
                      <option value="Redeem">Redeem</option>
                      <option value="Custom">Custom</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group ">
                <div class="row">
                  <div class="col-sm-4 ">
                    <label for="staticEmail" class=" col-form-label">Unit</label>
                  </div>
                  <div class="col-sm-8">
                    <select formControlName="unit" id="unit" class=" form-control">
                      <option value="Quantity #">Quantity #</option>
                      <option value="Currency $">Currency $</option>
                      <option value="Percent %">Percent %</option>
                      <option value="Ravel Points">Ravel Points</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group ">
                <div class="row">
                  <div class="col-sm-4 ">
                    <label for="staticEmail" class=" col-form-label">Amount</label>
                  </div>
                  <div class="col-sm-8">
                    <input class="form-control" type="number" name="name" formControlName="value" min="0" step="1">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-4 ">
                    <label for="staticEmail" class=" col-form-label">Name/Description</label>
                  </div>
                  <div class="col-sm-8">
                    <input class="form-control" type="text" name="pay" formControlName="name" placeholder="">
                  </div>
                </div>
              </div>
              <!--
          <div *ngIf="i != '0'" class="icon-size" (click)="removeCategory(i)" style="margin-right: 15px;float:right;cursor: pointer;    color: #fff;font-size: 18px;">X
          </div> -->
            </div>
          </div>
          <i class="fa fa-plus" (click)="addCategory()" style="float: right; margin-top: 7px;"></i>
          <span type="button" (mouseenter)="mouseover()"
            style="margin-right: 5px;float:right; margin-top: 10px; font-weight: 800;">Add variable to continue
          </span>
          <div *ngIf="tooltip == true" class="lorem-ipsum">
            <button type="button" class="btn btn-secondary lorum-button" data-toggle="tooltip" data-placement="top"
              title="Tooltip on top">
              <span class="tooltip-close" (click)="closeTooltip($event)"><i class="fa fa-times"
                  aria-hidden="true"></i></span>

              <div class="pop-text">
                <p class="text-center"><b>Design a member discount for your Ravel customers.</b></p>
              </div>
              <div class="pop-text-1">
                <p><b> For example:</b></p>
                <p>Buy <span style="width: 70%;"> (offer/action)</span></p>
                <p>Quantity= <span style="width: 70%;"> (unit)</span> </p>
                <p>1 <span style="width: 70%;">(amount)</span> </p>
                <p>Pizza <span style="width: 70%;">(name/description of the item/action/result)</span> </p>
              </div>
              <div class="pop-text-1">
                <p>+ <span style="width: 70%;"> (add a variable)</span></p>
              </div>
              <div class="pop-text-1">
                <p>Get <span style="width: 70%;"> (offer/action)</span></p>
                <p>Percent= <span style="width: 70%;"> (unit)</span> </p>
                <p>50<span style="width: 70%;">(amount)</span> </p>
                <p>Off a 2nd Pizza <span style="width: 70%;">(name/description of the item/action/result)</span> </p>
              </div>
              <div class="pop-text-1">
                <!-- <p>*Offer valid every weekend (terms and conditions of the discount)</p> -->
              </div>
              <div class="pop-text-1">
                <p>Combine multiple customer actions by clicking the plus + symbol:</p>
                <p>“Buy 1 Pizza (action 1)(+) redeem 50 Ravel Points
                  (action 2) and get a second 2nd pizza for free (result)”</p>
              </div>
              <div class="pop-text-1 pop-text-bottom">
                <p>The discounted "Community Builder" subscription plan requires Merchants
                  to offer an exclusive discount of at least 5% in added value to Ravel members
                  who redeem Ravel Reward Points. </p>
              </div>
              <!-- <div class="triangle-bottom"></div> -->
            </button>
          </div>
          <br>
          <br>
          <div class="w-100">
          </div>
          <button class="btn btn-primary" (click)="openImageModal(imageModal)">View Sample Discount</button>
          <!-- <button>Sample Discount</button> -->
          <button type="submit" class="sign-up-btn btn btn-primary save-button" (click)="openModal(action)">Preview
            Discount</button>
          <div class="form-group term">
            <label>
              <input type="checkbox" style="margin-right: 5px;" formControlName="termsAccepted"
                (change)="onTermsAcceptedChange()" />
              We certify this discount is Exclusive or extends Most Favored Customer status/pricing to Ravel members and
              adds value/savings of at least 5%.
            </label>
            <!-- <div *ngIf="form.controls['termsAccepted'].invalid && (form.controls['termsAccepted'].touched)" style="color: red;">
              You must certify this discount before submitting.
            </div> -->
          </div>
          <div class="form-group">
            <label for="ravelPointsRequired">Ravel Reward Points Required</label>
            <input type="number" class="form-control" id="ravelPointsRequired" formControlName="ravelPointsRequired"
              min="0" max="500" placeholder="0-500" />
            <small class="form-text text-muted">
              Points not required but no more than 500 may be requested.
            </small>
            <div *ngIf="form.controls['ravelPointsRequired'].invalid && form.controls['ravelPointsRequired'].touched"
              style="color: red;">
              Please enter a value between 0 and 500 (required).
            </div>
          </div>
          <div class="form-group">
            <label for="exampleFormControlTextarea1">Ravel Points & Conditions</label>
            <textarea formControlName="terms" (keyup)="setTerms($event)" class="form-control textareaa"
              id="exampleFormControlTextarea1" rows="3"
              placeholder="ex. 100 Ravel Points. Cannot be combined with other offers"></textarea>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #action let-modal>
  <div class="modal-header">
  </div>
  <div class="modal-body">
    <div style="padding:20px; text-align: center;" [innerText]="finalStr"></div>
    <div style="padding:20px; text-align: center;" [innerText]="terms"></div>
    <div style="    display: flex;
    align-items: center;
    justify-content: space-evenly;
">
      <button (click)="modal.dismiss('Cross click')" type="submit" style="text-align: center;display: block;"
        class="btn btn-primary">Edit</button>
      <button (click)="saveData()" type="submit" class="sign-up-btn btn" style="    background-color: green;
    color: white;
    border: green;">Save</button>
      <!-- btn btn-primary -->
    </div>
  </div>
</ng-template>

<ng-template #imageModal let-modal>
  <div class="modal-header">
    <!-- You can add a close button here if needed -->
    <button class="imageModals" (click)="closeModal()">X</button>
  </div>
  <div class="modal-body" style="padding:20px; text-align: center;">
    <div class="image">
      <img src="assets/SampleDiscount.png" alt="Sample Image" style="max-width: 100%">
    </div>
  </div>
</ng-template>